// extracted by mini-css-extract-plugin
export default {"recos":"m5-z","productCardOverride":"n5-z","rowHasBadge":"o5-z"};